import { APIProgress, ErrorCode } from '@shopee-user/api-constants';
import { BusinessAccount } from '@shopee-user/account-constants';
import { LoginStatus, State } from './types';
import { REDUCER_NAME } from './constants';
import getIn from '@shopee/get-in';

export function getAccountInfo(state: State): BusinessAccount | null {
  return getIn(state, [REDUCER_NAME, 'account'], null);
}

export function getAccountAPIProgress(state: State): APIProgress {
  return getIn(state, [REDUCER_NAME, 'accountProgress'], APIProgress.Init);
}

export function getAccountError(state: State): ErrorCode | null {
  return getIn(state, [REDUCER_NAME, 'accountError'], null);
}

export function getLoginStatus(state: State): LoginStatus | null {
  return getIn(state, [REDUCER_NAME, 'loginStatus'], null);
}

export function getLoginStatusAPIProgress(state: State): APIProgress {
  return getIn(state, [REDUCER_NAME, 'loginStatusProgress'], APIProgress.Init);
}

export function isOneCredentialLinked(state: State): boolean {
  return getIn(state, [REDUCER_NAME, 'oneCredentialLinked'], false);
}

export function isOneCredentialWhitelisted(state: State): boolean {
  return getIn(state, [REDUCER_NAME, 'oneCredentialWhitelisted'], false);
}
